import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideDefaultConfig } from '@spartacus/core';
import { defaultOnNavigateConfig } from './config/default-on-navigate-config';
import { OnNavigateService } from './on-navigate.service';

@NgModule({
  imports: [
    RouterModule.forRoot([], {
    anchorScrolling: 'enabled',
    initialNavigation: 'enabledBlocking',
}),
  ],
  providers: [
    provideDefaultConfig(defaultOnNavigateConfig),
    provideAppInitializer(() => {
        const initializerFn = (onNavigateFactory)(inject(OnNavigateService));
        return initializerFn();
      }),
  ],
})
export class AppRoutingModule {}

export function onNavigateFactory(onNavigateService: OnNavigateService): () => void {
  const isReady = () => onNavigateService.initializeWithConfig();
  return isReady;
}
